import { LANG_SERVICE_SET } from 'services/LanguageService/languageService.types';
import moment from 'moment';
export var locSetLanguage = function (language, i18n) {
    return function (dispatch) {
        i18n.changeLanguage(language);
        moment.locale(language);
        dispatch({ type: LANG_SERVICE_SET, payload: language });
    };
};
